// PwaUpdateToast — shown when the service worker has a new version ready.
// Uses vite-plugin-pwa's useRegisterSW hook (virtual module).
// registerType is 'prompt' and workbox runs with skipWaiting:false, so a new
// SW installs and then WAITS. Nothing changes for the user until they click
// Refresh here, which posts SKIP_WAITING via updateServiceWorker(true).
// Consequence when debugging: a pushed fix is not live in an open tab until the
// toast is accepted — up to 60 s away, since that is the update poll interval.

import { useRegisterSW } from 'virtual:pwa-register/react';

export function PwaUpdateToast() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swScriptUrl, registration) {
      // Poll every 60 s in production so long-lived tabs catch updates.
      if (registration) {
        setInterval(() => {
          registration.update().catch(() => {});
        }, 60_000);
      }
    },
    onRegisterError(error) {
      console.error('[Cave84 SW] registration failed:', error);
    },
  });

  if (!needRefresh) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-4
                 px-5 py-3 rounded-xl shadow-2xl
                 bg-surface-elevated border border-border-subtle
                 text-text-primary text-sm font-body
                 animate-in fade-in slide-in-from-bottom-4 duration-300"
      style={{ minWidth: 280, maxWidth: 'calc(100vw - 2rem)' }}
    >
      <span className="flex-1">✦ New version available — reload to apply.</span>
      <button
        onClick={() => updateServiceWorker(true)}
        className="shrink-0 px-3 py-1 rounded-lg bg-accent text-white text-xs font-semibold
                   hover:bg-accent/80 transition-colors focus-visible:outline-none
                   focus-visible:ring-2 focus-visible:ring-accent"
      >
        Refresh
      </button>
      <button
        onClick={() => setNeedRefresh(false)}
        aria-label="Dismiss update notification"
        className="shrink-0 text-text-tertiary hover:text-text-primary transition-colors
                   focus-visible:outline-none"
      >
        ✕
      </button>
    </div>
  );
}
